import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";
import Login from "./pages/Login";
import SubAccounts from "./pages/SubAccounts";
import OpLog from "./pages/OpLog";
import WeixinPublic from "./pages/WeixinPublic";
import DomainBind from "./pages/DomainBind";
import UnderDevelopment from "./pages/UnderDevelopment";
import JoinGroup from "./pages/JoinGroup";
import Qrcode from "./pages/JoinGroup/Qrcode";
import RichEditorTest from "./pages/RichEditorTest";
import H5Editor from "./pages/H5Editor";
import H5Preview from "./pages/H5Preview";
import Pages from "./pages/Pages";
import OrderList from "./pages/JoinGroup/OrderList";
import Distribution from "./pages/JoinGroup/Distribution";
import UserDetail from "./pages/UserDetail";
import Points from "./pages/Points";
import Cash from "./pages/Cash";
import Categories from "./pages/Categories";
import Products from "./pages/Products";
import ProductEdit from "./pages/Products/edit";
import Orders from "./pages/Orders";
import Coupons from "./pages/Coupons";
import Comments from "./pages/Comments";
import Stores from "./pages/Stores";
import Slides from "./pages/Slides";
import Vipcards from "./pages/VipCards";
import Fees from "./pages/Fees";
import Articles from "./pages/Articles";
import Channels from './pages/Channels';
import Teachers from './pages/Teachers';
import Lessons from './pages/Lessons';
import LessonSubjects from './pages/LessonSubjects';
import AllCategories from './pages/AllCategories';
import LessonOrders from './pages/LessonOrders';
import UserVipCards from './pages/UserVipCards';
import SpFiles from "./pages/SpFiles";
import SpecialPages from "./pages/SpecialPages";
import SpecialPosters from "./pages/SpecialPosters";
import XcxTheme from "./pages/XcxTheme";
import HotspotEditor from "./pages/HotspotEditor";
import PosterEditor from "./pages/PosterEditor";
import SectionTplEditor from "./pages/SectionTplEditor";
import Templates from "./pages/Templates";
import QrCodeGenerator from "./pages/QrCodeGenerator";
import XcxVersionManager from "./pages/XcxVersionManager";
import XcxDataCube from "./pages/XcxDataCube";
import XcxDataScreen from "./pages/XcxDataScreen";
import AllFields from './pages/AllFields';
import AllFieldVals from './pages/AllFieldVals';
import FormManage from './pages/Form';
import FormSuRecords from './pages/FormSuRecords';
import AllFieldValObjs from './pages/AllFieldValObjs';
import Meetings from './pages/Meetings';
import UserContracts from './pages/UserContracts';
import UserVerify from './pages/UserVerify';
import FddTpls from './pages/FddTpls';
import FddTasks from './pages/FddTasks';
import UserAdmin from './pages/UserAdmin';
import AccountAssets from './pages/AccountAssets';

const PrivateRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const location = useLocation();

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

const AppContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = React.useState(() => {
    return localStorage.getItem('isLoggedIn') === 'true';
  });

  const handleLogin = () => {
    setIsLoggedIn(true);
    const from = location.state?.from?.pathname || "/";
    navigate(from);
  };

  const getCurrentKey = () => {
    const path = location.pathname.substring(1) || 'dashboard';
    return path.charAt(0).toUpperCase() + path.slice(1);
  };

  if (!isLoggedIn && location.pathname !== '/login') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (location.pathname === '/login') {
    return <Login onLogin={handleLogin} />;
  }

  if (location.pathname === '/h5preview') {
    return <H5Preview />;
  }

  return (
    <MainLayout selectedKey={getCurrentKey()} onSelect={data => navigate(`/${data.itemKey.toLowerCase()}`)}>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/users" element={<Users />} />
        <Route path="/user/:userId" element={<UserDetail />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/subaccounts" element={<SubAccounts />} />
        <Route path="/oplog" element={<OpLog />} />
        <Route path="/weixinpublic" element={<WeixinPublic />} />
        <Route path="/domainbind" element={<DomainBind />} />
        <Route path="/joingroup" element={<JoinGroup />} />
        <Route path="/qrcode" element={<Qrcode />} />
        <Route path="/richeditortest" element={<RichEditorTest />} />
        <Route path="/h5editor" element={<H5Editor />} />
        <Route path="/h5preview" element={<H5Preview />} />
        <Route path="/pages" element={<Pages />} />
        <Route path="/orderlist" element={<OrderList />} />
        <Route path="/distribution" element={<Distribution />} />
        <Route path="/points" element={<Points />} />
        <Route path="/cash" element={<Cash />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/add" element={<ProductEdit />} />
        <Route path="/products/edit/:id" element={<ProductEdit />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/coupons" element={<Coupons />} />
        <Route path="/comments" element={<Comments />} />
        <Route path="/stores" element={<Stores />} />
        <Route path="/slides" element={<Slides />} />
        <Route path="/vipcards" element={<Vipcards />} />
        <Route path="/fees" element={<Fees />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/channels" element={<Channels />} />
        <Route path="/teachers" element={<Teachers />} />
        <Route path="/lessons" element={<Lessons />} />
        <Route path="/lessonsubjects" element={<LessonSubjects />} />
        <Route path="/lessonorders" element={<LessonOrders />} />
        <Route path="/allcategories" element={<AllCategories />} />
        <Route path="/uservipcard" element={<UserVipCards />} />
        <Route path="/spfiles" element={<SpFiles />} />
        <Route path="/specialpages" element={<SpecialPages />} />
        <Route path="/specialposters" element={<SpecialPosters />} />
        <Route path="/xcxtheme" element={<XcxTheme />} />
        <Route path="/hotspoteditor" element={<HotspotEditor />} />
        <Route path="/postereditor" element={<PosterEditor />} />
        <Route path="/sectiontpleditor" element={<SectionTplEditor />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/qrcodegenerator" element={<QrCodeGenerator />} />
        <Route path="/xcxversionmanager" element={<XcxVersionManager />} />
        <Route path="/xcxdatacube" element={<XcxDataCube />} />
        <Route path="/xcxdatascreen" element={<XcxDataScreen />} />
        <Route path="/allfields" element={<AllFields />} />
        <Route path="/allfieldvals" element={<AllFieldVals />} />
        <Route path="/form" element={<FormManage />} />
        <Route path="/formsurecords" element={<FormSuRecords />} />
        <Route path="/allfieldvalobjs" element={<AllFieldValObjs />} />
        <Route path="/meetings" element={<Meetings />} />
        <Route path="/usercontracts" element={<UserContracts />} />
        <Route path="/userverify" element={<UserVerify />} />
        <Route path="/fddtpls" element={<FddTpls />} />
        <Route path="/fddtasks" element={<FddTasks />} />
        <Route path="/useradmin" element={<UserAdmin />} />
        <Route path="/accountassets" element={<PrivateRoute><AccountAssets /></PrivateRoute>} />
        <Route path="*" element={<UnderDevelopment title={getCurrentKey()} />} />
      </Routes>
    </MainLayout>
  );
};

const Component = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default Component;
